import { Component, Vue } from 'vue-property-decorator'
import CAIG0040Service from './CAIG0040Service'
import CAIG0040ViewModel from './CAIG0040ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import CommonConstants from '@/common/CommonConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent, fixedContentNoLogin } from '@/assets/js/main.js'
import { DigitalBookButton } from '@/common/utils/modules-util'
@Component({
  name: 'CAIG0040',
  components: {}
  })
export default class CAIG0040Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private caig0040Service = new CAIG0040Service()
  private caig0040ViewModel: CAIG0040ViewModel = {
    internetUsageGuideUseEnvInfo: {
      content: ''
    },
    batchDispDiv: ''
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    fixedContentNoLogin()
    await this.init()
    this.$nextTick(() => {
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const caia0040ResponseModel = await this.caig0040Service.callAPICAIA0040()

    if (
      CommonUtil.isNotEmpty(caia0040ResponseModel.internetUsageGuideUseEnvInfo)
    ) {
      this.caig0040ViewModel.internetUsageGuideUseEnvInfo.content =
        CommonUtil.replacePathCMS(
          caia0040ResponseModel.internetUsageGuideUseEnvInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caia0040ResponseModel.internetUsageGuideUseEnvInfo.path
        )
    } else {
      this.caig0040ViewModel.internetUsageGuideUseEnvInfo = null
    }
    this.caig0040ViewModel.batchDispDiv = caia0040ResponseModel.batchDispDiv
  }

  /**
   * 前に戻るボタン押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
